import * as React from 'react';
import {
  useCommonContent,
  useOneCmsLocalePartners,
} from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import {
  filterCenturionProvidersForDisplay,
  getAnchorId,
} from '@/helpers/utils';
import Divider from '../common/Divider';
import PageNavigation from '../common/PageNavigation';

const TermsAndConditionsPage = () => {
  const {
    footer: { additionalInfo },
  } = useCommonContent();
  const partners = useOneCmsLocalePartners();
  // Filter partners so only 1 Centurion provider shows (each country Centurion Provider is a separate array entry)
  const filteredPartners = filterCenturionProvidersForDisplay(
    partners
  ) as Array<{
    partner_name: string;
    terms: string;
    partner_id: string;
  }>;

  const tncSectionHeader = 'TermsAndConditions';
  const menus = [
    {
      menuSectionHeader: tncSectionHeader,
      items: filteredPartners.map(({ partner_name: partnerName }) => ({
        type: 'terms' as const,
        name: partnerName,
      })),
      hideSectionHeader: true,
    },
  ];

  return (
    <div className="tw-mx-auto tw-max-w-screen-x2l tw-px-4 md_tw-px-6 lg_tw-px-8 xl_tw-px-10">
      <div className="tw-my-10 tw-flex tw-w-full tw-items-center tw-justify-center">
        <h1 className="text-align-center color-text-emphasis tw-heading-xl-book tw-col-span-8 tw-col-start-3 tw-font-serif md_tw-heading-4xl-book md_tw-font-serif">
          {additionalInfo?.termsLabel}
        </h1>
      </div>
      <Divider />
      <section className="tw-my-10 tw-grid tw-grid-cols-1 md_tw-my-16 lg_tw-grid-cols-12">
        <div className="tw-col-span-2">
          <PageNavigation menus={menus} />
        </div>
        <div className="tw-col-span-8 tw-grid tw-grid-cols-1 lg_tw-grid-cols-8">
          <div className="tw-col-span-6 tw-col-start-2 tw-mb-10 tw-text-xl md_tw-mb-16 lg_tw-text-2xl">
            {filteredPartners.map(
              (
                { partner_name: partnerName, terms, partner_id: partnerId },
                idx
              ) => (
                <React.Fragment key={partnerName}>
                  <div
                    id={getAnchorId({
                      type: 'terms',
                      name: partnerName,
                      title: undefined,
                      idx,
                      section: tncSectionHeader,
                    })}
                  >
                    <h3
                      id={`${partnerId}-terms-header`}
                      className="tw-pb-2 tw-font-sans tw-text-base tw-font-bold tw-text-gray-900"
                    >
                      {partnerName}
                    </h3>
                    <p
                      className="margin-2-b tw-font-dls tw-text-base a-children_tw-underline focus_a-children_tw-text-blue-bright-600"
                      dangerouslySetInnerHTML={{
                        __html: terms,
                      }}
                    />
                  </div>
                  {idx < filteredPartners.length - 1 && <Divider />}
                </React.Fragment>
              )
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditionsPage;
